import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation deleteSystemUiModuleComponent($id: String!) {
    deleteSystemUiModuleComponent(id: $id) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const deleteSystemUiModuleComponentRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_ui_module_component/delete_system_ui_module_component',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.deleteSystemUiModuleComponent;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const deleteSystemUiModuleComponentSlice = createSlice({
  name: 'delete_system_ui_module_component',
  initialState: initialState,
  reducers: {
    deleteSystemUiModuleComponentClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(deleteSystemUiModuleComponentRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      deleteSystemUiModuleComponentRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(
      deleteSystemUiModuleComponentRequest.rejected,
      (state, action) => {
        state.error = action.payload as Error || {
          message: 'Failed to fetch',
          statusCode: '500'
        };
        state.loading = false;
      }
    );
  }
});

export const { deleteSystemUiModuleComponentClear } =
deleteSystemUiModuleComponentSlice.actions;

export const deleteSystemUiModuleComponent = createSelector(
  (state: RootState) =>
  state.systemUiModuleComponent.deleteSystemUiModuleComponent.result,
  (state: RootState) =>
  state.systemUiModuleComponent.deleteSystemUiModuleComponent.error,
  (state: RootState) =>
  state.systemUiModuleComponent.deleteSystemUiModuleComponent.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default deleteSystemUiModuleComponentSlice.reducer;